/* global axios */
import ApiClient from './ApiClient';

class ReleaseNotesAPI extends ApiClient {
  constructor() {
    super('release_notes', { accountScoped: false });
  }

  getToday() {
    return axios.get(`${this.url}/today`);
  }
}

export default new ReleaseNotesAPI();
